document.addEventListener('DOMContentLoaded', function () {
  const baseLink = document.body.dataset.altLink?.trim();
  const currentLang = document.body.dataset.currentLang?.toLowerCase();
  const langList = document.getElementById('lang-list-header');
  if (!langList || !currentLang) return;

  const langMap = {
    english: 'en',
    français: 'fr',
    deutsch: 'de',
    español: 'es',
    italiano: 'it',
    polski: 'pl',
  };

  const fallbackPaths = ['/collections', '/collections/all', '/cart', '/collections/', '/collections/all/', '/cart/'];
  const currentPath = window.location.pathname;
  const isFallbackPage = fallbackPaths.includes(currentPath);

  const links = langList.querySelectorAll('a');

  links.forEach((link) => {
    const label = link.textContent.trim().toLowerCase();
    const targetLang = langMap[label];
    if (!targetLang || targetLang === currentLang) return;

    if (isFallbackPage) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const origin = 'https://lyofood.com';
        let targetPath = currentPath;
        if (targetLang !== 'en') {
          targetPath = `/${targetLang}${currentPath}`;
        }
        const finalURL = `${origin}${targetPath}`;
        window.location.href = finalURL;
      });
      return;
    }

    if (!baseLink) return;

    link.addEventListener('click', function (e) {
      e.preventDefault();
      try {
        const url = new URL(baseLink);
        let newPath = url.pathname;

        if (targetLang !== 'en' && !url.pathname.startsWith(`/${targetLang}/`)) {
          newPath = `/${targetLang}${url.pathname}`;
        }

        const finalURL = `${url.origin}${newPath}`;
        window.location.href = finalURL;
      } catch (error) {
        console.warn('Incorrect URL in metafield:', baseLink);
      }
    });
  });
});
